import {ALLUSERS} from "../../constant/ActionType";

export default function UsersReducer(state = {
    users:[],
    statusCode: null,
}, action) {
    switch (action.type) {    
        case ALLUSERS:
			return { ...state,
				users: action.data?.data,
                statusCode:action.status
            };

        default:
    }
    return state;
}
